import React from "react";
import queryString from 'query-string'
import axios from 'axios'
import Cookies from 'universal-cookie';
import { setSSOValue, getIsSSO, getSSOEnabled } from '../../services/constants';
import {
    ApiService as ApiService1,
    ApiService,
  } from "../../services/ApiService1";

const cookies = new Cookies();

const getAPIEndpoint = () => localStorage.getItem('API_ENDPOINT')
const getEndpoint = () => '/KPIIPModule/api/v1/XELSYSADM'

class LoginCallback extends React.Component {
    async componentWillMount() {
        // const token = this.getAccessToken()
        const tokenData = queryString.parse(window.location.search)
        console.log({tokenData, setSSOValue: setSSOValue(), local: localStorage, getIsSSO: getIsSSO(), getSSOEnabled: getSSOEnabled()})
        const token = tokenData.code
        if(token) {
            // clearStorage();
            // localStorage.removeItem("isUserLogin")
            // localStorage.setItem("AUTH_TOKEN", token);
            // setTimeout(() => {
            //     window.location.href = "/dashboard"
            // }, 2000);
            const data = await axios.post(`${getAPIEndpoint()}${getEndpoint()}/login${setSSOValue()}`, {}, {
                headers: {
                    AuthorizationCode: token
                }
            })
            if(data.status === 200) {
                // cookies.set('USER_PWD_TOKEN', userPwdToken, { path: '/' });
                const { loginDateAndTime, userName } = data.data || {}
                const clientId = window.location.pathname.split('/')[2]
                const token1 = data.data.cookies.split(':')[0] + ':'
              
                const token2 = data.data.cookies.split(':')[1]
               
                cookies.set('JWT_ACCESSTOKEN1', token1 || "", { path: '/' });
                cookies.set('JWT_ACCESSTOKEN2', token2 || "", { path: '/' });
             
                // cookies.set('JWT_ACCESSTOKEN', data.data.cookies || "", { path: '/' });
                cookies.set('REGISTERED_APPNAME', clientId, { path: '/' });
                cookies.set('LOGGEDIN_USERID', userName, { path: '/' });
                cookies.set('LAST_LOGIN', loginDateAndTime || "", { path: '/' });

                const roles = await ApiService.getSSOAdminUserRole();
                cookies.set('USER_ADMIN_ROLE', roles.userOperationalRole || "", { path: '/' });

                // window.location.href = `/iga/${clientId}/certification`;
                const role = cookies.get('USER_ADMIN_ROLE');
                const isEmployee = (role || "").includes("Manager")
                // window.location.href = isEmployee ? `/iga/${currentClientId}/request/request-for-self` : `/iga/${currentClientId}/`;
                window.location.href = isEmployee ? `/iga/${clientId}/certification` : `/iga/${clientId}/admin/dashboard`;
            }
            console.log({data})
            // const data = await ApiService.localLogin({})
        } else {
            // window.location.href = "/"
        }
    }

    render() {
        return (
            <div className="text-center">
                <h3>Authenticating...</h3>
            </div>
        )
    }
}

export default LoginCallback
